import { Routes, Route, Link } from "react-router-dom";
import { SignedIn, SignedOut, UserButton } from "@clerk/clerk-react";
import { Landing } from "./routes/Landing.js";
import { Me } from "./routes/Me.js";
import { Plan } from "./routes/Plan.js";
import { Vision } from "./routes/Vision.js";
import { AdminCrawl } from "./routes/AdminCrawl.js";
import { AdminFind } from "./routes/AdminFind.js";
import { VendorStore } from "./routes/VendorStore.js";
import { VendorsBrowse } from "./routes/VendorsBrowse.js";
import { Saved } from "./routes/Saved.js";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4 border-b border-stone-200 flex items-center justify-between">
        <Link to="/" className="font-display text-xl tracking-tight">
          BridePath
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <SignedIn>
            <Link to="/plan" className="text-stone-600 hover:text-stone-900">
              Plan
            </Link>
            <Link to="/vendors" className="text-stone-600 hover:text-stone-900">
              Vendors
            </Link>
            <Link to="/saved" className="text-stone-600 hover:text-stone-900">
              Saved
            </Link>
            <Link to="/admin/crawl" className="text-stone-400 hover:text-stone-700 text-xs">
              debug
            </Link>
            <Link to="/me" className="text-stone-400 hover:text-stone-700 text-xs">
              /me
            </Link>
            <UserButton afterSignOutUrl="/" />
          </SignedIn>
          <SignedOut>
            <span className="text-stone-500">signed out</span>
          </SignedOut>
        </nav>
      </header>
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/me" element={<Me />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/vision/:jobId" element={<Vision />} />
          <Route path="/admin/crawl" element={<AdminCrawl />} />
          <Route path="/admin/crawl/:traceId" element={<AdminCrawl />} />
          <Route path="/admin/find" element={<AdminFind />} />
          <Route path="/vendor/:id" element={<VendorStore />} />
          <Route path="/vendors" element={<VendorsBrowse />} />
          <Route path="/saved" element={<Saved />} />
        </Routes>
      </main>
    </div>
  );
}
